(() => {
  const fill = (dialog) => {
    const kit = dialog.closest('.lp-kits__kit');
    const track = dialog.querySelector('[data-lp-scents-track]');
    if (!kit || !track) return;

    kit
      .querySelectorAll('.lp-kits__viewport [data-lp-scent-slide]')
      .forEach((slide) => track.append(slide));
  };

  const open = (dialog, index) => {
    if (!dialog || dialog.open) return;

    dialog.showModal();
    dialog.dispatchEvent(
      new CustomEvent('lp-carousel:goto', { detail: { index: index, instant: true } })
    );
  };

  const openFromCard = (opener) => {
    const kit = opener.closest('.lp-kits__kit');
    if (!kit) return false;

    const cards = Array.from(kit.querySelectorAll('.lp-kits__viewport .lp-slider__slide'));
    const index = cards.indexOf(opener.closest('.lp-slider__slide'));

    open(kit.querySelector('[data-lp-scents-dialog]'), Math.max(0, index));

    return true;
  };

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('[data-lp-scents-dialog]');
    if (dialog) {
      if (event.target === dialog || event.target.closest('[data-lp-scents-close]')) dialog.close();
      return;
    }

    const opener = event.target.closest('[data-lp-scents]');
    if (!opener || openFromCard(opener)) return;

    const slot = opener.getAttribute('data-slot');
    if (slot) open(document.querySelector(`[data-lp-scents-dialog][data-bundle-kit="${slot}"]`), 0);
  });

  const fillAll = (scope) => {
    if (scope instanceof Element && scope.matches('[data-lp-scents-dialog]')) fill(scope);
    scope.querySelectorAll('[data-lp-scents-dialog]').forEach(fill);
  };

  fillAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) fillAll(event.target);
  });
})();
